import React, { useContext, useState } from "react";

const RaceContext = React.createContext();
const RaceUpdateContext = React.createContext();

export function useRace() {
  return useContext(RaceContext);
}

export function useRaceUpdate() {
  return useContext(RaceUpdateContext);
}

export function RaceProvider({ children }) {
  const [race, setRace] = useState("all");

  function updateRace(y) {
    setRace(y);
  }

  return (
    <RaceContext.Provider value={race}>
      <RaceUpdateContext.Provider value={updateRace}>
        {children}
      </RaceUpdateContext.Provider>
    </RaceContext.Provider>
  );
}
